import axios from 'axios';
import { keycloak } from './KeyCloakService';

const axiosCms = axios.create({
  baseURL: process.env.REACT_APP_CMS_EP,
  timeout: 10000,
});
axiosCms.interceptors.request.use (
  function (config) {
    const token = keycloak.token;
    if (token) config.headers.Authorization = 'Bearer '+token;
    return config;
  },
  function (error) {
    return Promise.reject (error);
  }
);
/*axiosCms.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Use Keycloak's updateToken method
      // minValidity: 5 means "if the token expires in less than 5 seconds, refresh it"
      keycloak.updateToken(5).then((refreshed) => {
        if (refreshed) {
          // Token was refreshed! Retry the original request with new token
          const newToken = keycloak.token;
          error.config.headers.Authorization = `Bearer ${newToken}`;
          return axios(error.config);
        } else {
          // Token is still valid but we got a 401? Force login.
          keycloak.login();
        }
      }).catch(() => {
        // Refresh token failed/expired
        keycloak.login();
      });
    }
    return Promise.reject(error);
  }
);*/

class CmsService{
    static baseURL(){
      return process.env.REACT_APP_CMS_EP;
    }
    static async createQuestion(question) {
        question.que.id = null;
        return axiosCms.post('questions', question).then(res => res.data);      
    }
    static async updateQuestion(id,question) {
      return axiosCms.post('questions/'+id, question).then(res => res.data);      
    }
    static async getQuestion(id){
      return axiosCms.get('questions/'+id).then(res => res.data);
    }
    static async getSourceImage(procId,page){
      return axiosCms.get('procs/'+procId+'/image?page='+page,{responseType:'blob'}).then(res => res.data);
    }
    static async getQuestions(catId,itemType,options,difficulty,approved){
      var url='cats/'+catId+'/questions?d=1';
      if(itemType!=undefined && itemType!='ALL')
        url=url+'&itemType='+itemType;
      if(options!=undefined && options!='ALL')
        url=url+'&options='+options;
      if(difficulty!=undefined && difficulty!='ALL')
        url=url+'&difficulty='+difficulty;
      if(approved!=undefined && approved!='ALL')
        url=url+'&approved='+approved;

      return axiosCms.get(url).then(res => res.data);
    }
    static async lockQuestions(ids)
    {
        var idList = { ids: ids };
        return axiosCms.post('questions/lock',idList).then(res=>res.data);
    }
    static async unlockQuestions(ids)
    {
        var idList = { ids: ids };
        return axiosCms.post('questions/unlock',idList).then(res=>res.data);
    }
    static async approveQuestions(ids)
    {
        var idList = { ids: ids };
        return axiosCms.post('questions/approve',idList).then(res=>res.data);
    }
    static async disapproveQuestions(ids)
    {
        var idList = { ids: ids };
        return axiosCms.post('questions/disapprove',idList).then(res=>res.data);
    }
    static async moveQuestions(ids,catId)
    {
        var move = { ids: ids, catId:catId };
        return axiosCms.post('questions/move',move).then(res=>res.data);
    }
    static async addQuestionsToCat(ids,catId)
    {
        var add = { ids: ids, catId:catId };
        return axiosCms.post('questions/addToCat',add).then(res=>res.data);
    }
    static async removeQuestionsFromCat(ids,catId)
    {
        var remove = { ids: ids, catId:catId };
        return axiosCms.post('questions/addFromCat',remove).then(res=>res.data);
    }
    static async deleteQuestions(ids)
    {
        var idlist = { ids: ids };
        return axiosCms.post('questions/delete',idlist).then(res=>res.data);
    }
    static async setQuestionProperty(ids,propType,propValue)
    {
        var prop = { ids: ids, propType:propType,propValue:propValue };
        return axiosCms.post('questions/setProp',prop).then(res=>res.data);
    }
    static async getQuestionPreview(id,contentType)
    {
      if(contentType != undefined)
        return axiosCms.get('questions/'+id+'/preview?contentType='+contentType,{responseType: "arraybuffer"});
      else
        return axiosCms.get('questions/'+id+'/preview',{responseType: "arraybuffer"});
    }
    static async reviewQuestion(id,rev)
    {
      return axiosCms.post('questions/'+id+'/reviews',rev).then(res=>res.data);
    }
    static async getQuestionReviews(id)
    {
      return axiosCms.get('questions/'+id+'/reviews').then(res=>res.data);
    }
    static async getQuestionLogs(id)
    {
      return axiosCms.get('questions/'+id+'/logs').then(res=>res.data);
    }
    static async getImportedQuestions(id){
      return axiosCms.get('procs/'+id+'/questions').then(res=>res.data);
    }
    static async createGrp(grp) {
      grp.id = null;
      return axiosCms.post('grps', grp).then(res => res.data);      
    }
    static async updateGrp(id,grp) {
      return axiosCms.post('grps/'+id, grp).then(res => res.data);      
    }
    static async getGrp(id){
      return axiosCms.get('grps/'+id).then(res => res.data);
    }
    static async createRubric(rubric){
      rubric.id = null;
      return axiosCms.post('rubrics', rubric).then(res => res.data);      
    }
    static async getRubrics(){
      return axiosCms.get('rubrics').then(res => res.data);
    }
    static async getRubric(id){
      return axiosCms.get('rubrics/'+id).then(res => res.data);
    }
    static async updateRubric(rubric){
      return axiosCms.post('rubrics/'+rubric.id,rubric).then(res=>res.data);
    }
    static async importQuestions(catId,loadData,progressHandler){
      var formData = new FormData();
      formData.append("fileName",loadData.file.name);
      formData.append("file",loadData.file);
      formData.append("fileType",loadData.file.type);
      formData.append("questionPattern",loadData.questionPattern);
      formData.append("optionPattern",loadData.optionPattern);
      formData.append("dataLinePattern",loadData.dataLinePattern);
      formData.append("itemType",loadData.itemType);
      formData.append("options",loadData.options);

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: progressHandler,
        timeout: 20000
      }      
      return axiosCms.post('cats/'+catId+'/questions/load',formData,config).then(res=>res.data);
    }
    static async uploadMedia(objId,mediaType,loadData,progressHandler){
      var formData = new FormData();
      formData.append("objId",objId);
      formData.append("fileName",loadData.file.name);
      formData.append("file",loadData.file);
      formData.append("fileType",loadData.file.type);
      formData.append("mediaType",mediaType);

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: progressHandler,
        timeout: 20000
      }      
      return axiosCms.post('media',formData,config).then(res=>res.data);
    }
    static async importQuestionsFromImageSource(catId,loadData,progressHandler){
      var formData = new FormData();
      formData.append("fileName",loadData.file.name);
      formData.append("file",loadData.file);
      formData.append("fileType",loadData.file.type);
      formData.append("itemType",loadData.itemType);
      formData.append("options",loadData.options);
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: progressHandler,
        timeout: 20000
      }      
      return axiosCms.post('cats/'+catId+'/questions/loadImage',formData,config).then(res=>res.data);
    }
    static async getProc(id)
    {
      return axiosCms.get('procs/'+id).then(res => res.data);
    }  
    static async getTemp(id)
    {
      return axiosCms.get('temps/'+id).then(res => res.data);
    }    
    static async createTemp(temp){
      temp.id = null;
      return axiosCms.post('temps', temp).then(res => res.data);      
    }
    static async getTemps(){
      return axiosCms.get('temps').then(res => res.data);
    }
    static async getBankCourses(parentId){
      return axiosCms.get('cats/'+parentId+'/crss').then(res => res.data);
    }
    static async updateTemp(id,temp){
      return axiosCms.post('temps/'+id,temp).then(res=>res.data);
    }
    static async deleteTemp(id){
      return axiosCms.delete('temps/'+id).then(res=>res.data);
    }
    static async generateDocs(test,ps,items)
    {
      //TODO
      var genDoc={
        props:{testName:test.name,testId:test.id,testType:test.examType,testDate:test.testDate,term:test.termName,testNo:test.testNo},
        docs:items,ps:ps
      };
      return axiosCms.post('temps/'+ps.tempId+'/generateDoc',genDoc).then(res=>res.data);
    }
    static async testprint(){
      var genDoc={
        props:{testname:'Deneme',id:100,testType:'LGS'},
        sects:[{qids:[1,2,3],sectProps:{sectname:'SectionA'}},
        {qids:[4,5,6],sectProps:{sectname:'SectionB'}}],
        ps:{tempId:13,
          separation:20,
          qnoHanging:true,
          qnoIndent:10,
          qnoPattern:"QNO.",
          qnoFont:"Arial",
          qnoFontSize:12,
          qnoStyle:1,
          optNoPattern:"OPT.",          
          optNoFont:"Arial",
          optNoFontSize:10,
          optNoStyle:2
        }
      };
      return axiosCms.post('temps/13/generateDoc',genDoc).then(res=>res.data);
    }
    static async getDatsByRefId(refId)
    {
      return axiosCms.get('ref/'+refId+'/dats').then(res=>res.data);
    }
    static async downloadDat(id)
    {
      return axiosCms.get('dats/'+id+'/odt',{timeout:100000,responseType:'blob'});
    }
    static async downloadDocAsPdf(id)
    {
      return axiosCms.get('dats/'+id+'/pdf',{timeout:100000,responseType:'blob'});
    }
    static async getCrt(id)
    {
      return axiosCms.get('crts/'+id).then(res => res.data);
    }    
    static async createCrt(crt){
      crt.id = null;
      return axiosCms.post('crts', crt).then(res => res.data);      
    }
    static async getCrts(catId){
      return axiosCms.get('cats/'+catId+'/crts').then(res => res.data);
    }
    static async updateCrt(id,crt){
      return axiosCms.post('crts/'+id,crt).then(res=>res.data);
    }
    static async deleteCrt(id){
      return axiosCms.delete('crts/'+id).then(res=>res.data);
    }
    static async createCrtItem(crtId,item){
      item.id = null;
      return axiosCms.post('crts/'+crtId+'/items', item).then(res => res.data);      
    }
    static async updateCrtItem(crtId,item){
      return axiosCms.post('crts/'+crtId+'/items/'+item.id, item).then(res => res.data);      
    }
    static async getCrtItems(crtId){
      return axiosCms.get('crts/'+crtId+'/items').then(res => res.data);
    }
    static async deleteCrtItem(crtId,itemId){
      return axiosCms.delete('crts/'+crtId+'/items/'+itemId).then(res=>res.data);
    }
    static async deleteCrtItems(crtId,itemIds){
      var idList = { ids: itemIds };
      return axiosCms.post('crts/'+crtId+'/items/deletemulti',idList, { headers: { "Content-Type": "application/json" }}).then(res=>res.data);
    }
    static async testAutoSelect(crtId){
      var params={crtId:crtId,avgDiff:2.45,criteria:[],excRatio:0.75};

      return axiosCms.post('crts/'+crtId+"/autoSelect",params).then(res=>res.data);
    }
    static async autoSelect(crtId,params){
      return axiosCms.post('crts/'+crtId+"/autoSelect",params).then(res=>res.data);
    }
    static async getAutoSelectResult(id)
    {
      return axiosCms.get('procs/'+id+'/autoSelectData').then(res => res.data);
    }  
}

export default CmsService;